import React from 'react';
import { Neo, NeoGrid, Routing, Views } from '@singularsystems/neo-react';
import ServiceProviderFileGroupingsVM from './ServiceProviderFileGroupingsVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import ServiceProviderFileGroupingLookup from '../Models/Lookups/ServiceProviderFileGroupingLookup';
import ManageServiceProviderFileGroupingComponent from '../Components/ManageServiceProviderFileGroupingComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { ServiceProviders } from '../../../AccessControl/Models/Commands/Security/Roles';
import { Misc, ModalUtils } from '@singularsystems/neo-core';

@observer
export default class ServiceProviderFileGroupingsView extends Views.ViewBase<ServiceProviderFileGroupingsVM> {

    constructor(props: unknown) {
        super("Service Providers", ServiceProviderFileGroupingsVM, props);
    }

    public beforeRouteChanged(props: Routing.IRouteChangedProps): void {
        super.beforeRouteChanged(props);

        const vm = this.viewModel.manageServiceProviderComponentVM;
        if (props.isNewView && vm.showManageServiceProviderFileGroupingInd && vm.hasUnsavedChanges) {
            props.leavePrompt = (async (): Promise<boolean> => {
                const result = await ModalUtils.showYesNo(
                    'Unsaved Settings Changes',
                    'You have unsaved changes. Are you sure you want to exit?'
                );

                return result === Misc.ModalResult.Yes;
            })();
        }
    }

    public render() {
        return (
            <>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.manageServiceProviderComponentVM.showManageServiceProviderFileGroupingInd &&
                    <ManageServiceProviderFileGroupingComponent
                        viewModel={this.viewModel.manageServiceProviderComponentVM}
                        tradeSftpTypeOptions={this.viewModel.tradeSftpTypeOptions}
                        onSave={() => this.viewModel.saveServiceProviderFileGrouping()}
                        onCancel={() => this.viewModel.cancel()}
                       />
                }
                {!this.viewModel.manageServiceProviderComponentVM.showManageServiceProviderFileGroupingInd &&
                    <Neo.Card title={TextConstants.Titles.ServiceProviders} className="m-1">
                        <div className="row pb-3">
                            <div className="col text-right">
                                <Neo.Button
                                    onClick={() => this.viewModel.addServiceProviderFileGrouping()}
                                    variant="primary" size="sm"
                                >{TextConstants.Buttons.AddServiceProvider}</Neo.Button>
                            </div>
                        </div>
                        <React.Fragment>
                            <Neo.Form model={this.viewModel.serviceProviderSearchCriteria} onSubmit={() => this.viewModel.serviceProviderSearchCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                <Neo.FormGroup
                                    suppressLabel={true}
                                    bind={this.viewModel.serviceProviderSearchCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchServiceProviderDetails}
                                    append={
                                        <Neo.Button className="btn-small" isSubmit variant="primary">
                                            <i className={`${this.viewModel.serviceProviderSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                        </Neo.Button>}
                                />
                            </Neo.Form>
                        </React.Fragment>
                        <React.Fragment>
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                                <div className="horizontalScroll inner-container">
                                    <NeoGrid.Grid<ServiceProviderFileGroupingLookup> className={"table-striped"}>
                                        {(item, meta) => (
                                            <NeoGrid.Row key={item.staticServiceProviderFileGroupingId}>
                                                <NeoGrid.Column display={meta.serviceProviderName} />
                                                <NeoGrid.Column display={meta.databaseName} />
                                                <NeoGrid.Column label={TextConstants.Labels.Broker} display={meta.serviceProviderGroupingName} />
                                                <NeoGrid.Column label={TextConstants.Labels.BrokerDescription} display={meta.groupingDescription} />
                                                <NeoGrid.Column label={TextConstants.Labels.IsOnShore} display={meta.isOnshoreInd} />
                                                <NeoGrid.Column label={TextConstants.Labels.IgnoreGrouping} display={meta.ignoreGroupingInd} />
                                                <NeoGrid.Column label={TextConstants.Labels.IsActive} display={meta.isActiveInd} />
                                                <NeoGrid.Column label={TextConstants.Labels.IgnoreExchangeRates} display={meta.ignoresExchangeRatesInd} />
                                                <NeoGrid.Column label={TextConstants.Labels.ImportsOnPublicHolidays} display={meta.importsPublicHolidaysInd} />
                                                <NeoGrid.Column label={TextConstants.Labels.ClientAlternativeRefSearch} display={meta.clientAltSearchInd} />
                                                <NeoGrid.Column display={meta.sortOrder} />
                                                <NeoGrid.Column label={TextConstants.Labels.ProvidesDividendGross} display={meta.provideDividendGrossInd} />
                                                <NeoGrid.Column label={TextConstants.Labels.UsesAccountCurrency} display={meta.useAccountCurrencyInd} />
                                                {this.viewModel.authorisationService.hasRole(ServiceProviders.Edit) &&
                                                    <NeoGrid.ButtonColumn label={TextConstants.Labels.Details} className="text-center">
                                                        <Neo.Button
                                                            onClick={() => this.viewModel.editServiceProviderFileGrouping(item)}
                                                            variant="primary" isOutline className="btn-small">
                                                            <i className="fa fa-edit"></i>
                                                        </Neo.Button>
                                                    </NeoGrid.ButtonColumn>
                                                }
                                                {this.viewModel.authorisationService.hasRole(ServiceProviders.ViewFiles) &&
                                                    <NeoGrid.ButtonColumn>
                                                        <Neo.Button
                                                            onClick={() => this.viewModel.viewFileSpecsForBroker(item.staticServiceProviderFileGroupingId, item.serviceProviderGroupingName)}
                                                            variant="secondary" isOutline className="btn-link">{TextConstants.Buttons.ViewConfiguredFiles}</Neo.Button>
                                                    </NeoGrid.ButtonColumn>
                                                }
                                            </NeoGrid.Row>
                                        )}
                                    </NeoGrid.Grid>
                                </div>
                            </Neo.Pager>
                        </React.Fragment>
                    </Neo.Card>
                }
            </>
        );
    }
}